import React, { Fragment } from 'react';
export function TrustBar() {
  const items = ['Free Estimates', 'Works With Most Insurance', 'Certified Technicians', 'Lifetime Workmanship Warranty', 'OEM & OEE Glass Available', 'ADAS Calibration In-House', 'Howell, Ann Arbor & Novi'];
  return <div className="bg-navy-900 text-white py-4 border-y border-navy-800" data-id="element-216">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        {/* Desktop View */}
        <div className="hidden md:flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm font-medium" data-id="element-218">
          {items.map((item, index) => <Fragment key={index} data-id="element-219">
              <span className="whitespace-nowrap text-slate-200" data-id="element-220">{item}</span>
              {index < items.length - 1 && <span className="text-brand-blue font-bold opacity-60" data-id="element-221">•</span>}
            </Fragment>)}
        </div>

        {/* Mobile View */}
        <div className="flex md:hidden flex-wrap justify-center gap-2" data-id="element-222">
          {items.map((item, index) => <span key={index} className="px-3 py-1.5 bg-navy-800 rounded-full text-xs font-medium text-slate-200 border border-navy-700" data-id="element-223">
              {item}
            </span>)}
        </div>
      </div>
    </div>;
}